import React from 'react';
import { MdDownload } from 'react-icons/md';
import { CSVLink } from 'react-csv';
import { Column } from '../bBITable/BBITable';

type DownloadCsvProps = {
  fileName: string;
  data: any;
  columnConfig: Column[]
  classname?: string;
};

//use bbi table column configs to create matching csv headers
const convertColumnConfigToHeaders = (columnConfig: Column[]) => {
  return columnConfig.map((column) => ({
    label: column.header,
    key: column.attribute,
  }));
};

const DownloadCsvButton = ({fileName, data, columnConfig}: DownloadCsvProps) => {
  const headers = convertColumnConfigToHeaders(columnConfig);
  return (
    <button>
      <CSVLink
        data={data}
        headers={headers}
        filename={fileName}
      >
        <MdDownload />
        Download
      </CSVLink>
    </button>
  );
};

export default DownloadCsvButton
